import { AudienceProfilerKPI } from 'components/Segmentation/SegmentationBubble/AudienceProfilerChartHeader'
import { ITEM_GROUP } from 'containers/RouteRestriction'
import { QueryType } from 'containers/Segmentation/SegmentationTable/config'

export const AudienceProfilerKPIOptions: AudienceProfilerKPI[] = [
  {
    id: 'purchaseChannel',
    value: 'purchaseChannel',
    label: 'Traditional vs Digital shopper',
    yAxisTitle: 'Traditional shopper',
    yAxisTooltipText: 'Proportion of Shoppers buying in-store',
    secondCrossFilters: [
      { variable_id: 27, answer_code: 3 }, // In-store
      { variable_id: 27, answer_code: 4 }, // Talking to someone over the phone
    ],
    xAxisTitle: 'Digital shopper',
    xAxisTooltipText: 'Proportion of Shoppers buying online',
    firstCrossFilters: [
      { variable_id: 27, answer_code: 1 }, // Online (delivered to a home, work, or other address)
      { variable_id: 27, answer_code: 2 }, // Click-and-Collect
    ],
    queryType: QueryType.PercentOfMarket,
  },
  {
    id: 'keyPurchaseTrigger',
    value: 'keyPurchaseTrigger',
    label: 'In-store vs Digital ad triggers',
    xAxisTitle: 'Digital ad trigger',
    xAxisTooltipText: 'Proportion saying social media or online advertising inspired them to buy.',
    firstCrossFilters: [
      { variable_id: 691, answer_code: 1 }, // Yes
    ],
    yAxisTitle: 'In-store trigger',
    yAxisTooltipText:
      'Proportion saying in-store staff, leaflets or display advertising inspired them to buy',
    secondCrossFilters: [
      { variable_id: 692, answer_code: 1 }, // Yes
    ],
    queryType: QueryType.PercentOfMarket,
  },
  {
    id: 'engagementComparison',
    value: 'engagementComparison',
    label: 'Brand vs Retailer engagements',
    xAxisTitle: 'Retailers visited (2 or more)',
    xAxisTooltipText: 'Number of retailers visited in-store / online as part of purchase journey',
    firstCrossFilters: [
      { variable_id: 695, answer_code: 2 }, // 2
      { variable_id: 695, answer_code: 3 }, // 3 or more
    ],
    yAxisTitle: 'Brands considered (3 or more)',
    yAxisTooltipText: 'Number of brands considered during purchase journey',
    secondCrossFilters: [
      { variable_id: 683, answer_code: 3 }, // 3
      { variable_id: 683, answer_code: 4 }, // 4
      { variable_id: 683, answer_code: 2919 }, // 5 or more
    ],
    queryType: QueryType.PercentOfMarket,
  },
  {
    id: 'keyChoiceFocus',
    value: 'keyChoiceFocus',
    label: 'Feature vs Brand importance',
    xAxisTitle: 'Brand is key',
    xAxisTooltipText: "Proportion mentioning 'Product brand' in their top 3 choice drivers.",
    firstCrossFilters: [{ variable_id: 697, answer_code: 1 }], // Yes
    yAxisTitle: 'Features are key',
    yAxisTooltipText: "Proportion mentioning 'Product features' in their top 3 choice drivers.",
    secondCrossFilters: [{ variable_id: 698, answer_code: 1 }], // Yes
    queryType: QueryType.PercentOfMarket,
  },
  {
    id: 'valuePriceSensitivity',
    value: 'valuePriceSensitivity',
    label: 'Price sensitivity vs Price paid ',
    secondaryVar: 'globalPurchasePriceMidPoint',
    xAxisTitle: 'Price paid',
    xAxisTooltipText: 'Average price paid (€).',
    firstCrossFilters: [
      { variable_id: 689, answer_code: 2 },
      { variable_id: 689, answer_code: 3 },
      { variable_id: 689, answer_code: 2920 },
    ],
    yAxisTitle: 'High price sensitivity',
    yAxisTooltipText:
      "Price sensitivity is a typology derived from answers given across the survey. A scoring system is developed from mentions of 'Price' and 'Promotions' at key brand and retailer choice drivers questions as well as 'Price comparison site' usage. The more mentions of these, the higher the sensitivity score.",
    queryType: QueryType.AveragePrice,
  },
  {
    id: 'valuePriceSensitivityMobile',
    value: 'valuePriceSensitivityMobile',
    label: 'Price sensitivity (Mobile) vs NSP ',
    secondaryVar: 'mobileHandsetNSPMidPoint',
    xAxisTitle: 'Non Subsidised Price (Mobile)',
    xAxisTooltipText: 'Average price paid (€).',
    firstCrossFilters: [
      { variable_id: 689, answer_code: 2 },
      { variable_id: 689, answer_code: 3 },
      { variable_id: 689, answer_code: 2920 },
    ],
    yAxisTitle: 'High price sensitivity',
    yAxisTooltipText:
      "Price sensitivity is a typology derived from answers given across the survey. A scoring system is developed from mentions of 'Price' and 'Promotions' at key brand and retailer choice drivers questions as well as 'Price comparison site' usage. The more mentions of these, the higher the sensitivity score.",
    queryType: QueryType.AveragePrice,
    restrictions: [ITEM_GROUP.MOBILE_PHONE],
  },
]
